import Icon from '../../components/Icon.vue'

Icon.register({"regular/file-archive":{"width":384,"height":512,"paths":[{"d":"M369.9 97.9L286.1 14.1A48-48 0 0 1 252.1 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9A48-48 0 0 1 369.9 97.9zM256 51.9L332.1 128H256V51.9zM336 464H48V48H127.7V64H159.7V48H208V152C208 165.3 218.7 176 232 176H336V464zM192.3 96H160.3V64H192.3V96zM160.3 96V128H128.3V96H160.3zM160.3 160V192H128.3V160H160.3zM192.3 160H160.3V128H192.3V160zM194.2 265.7A12-12 0 0 1 182.4 256H160.3V224H128.3V256L108.6 353.1C102 385.6 126.8 416 160 416 193.1 416 217.9 385.8 211.5 353.4L194.2 265.7zM160.3 390.1C142.4 390.1 127.8 378 127.8 363 127.8 348.1 142.4 336 160.3 336S192.7 348.1 192.7 363C192.7 378 178.2 390.1 160.3 390.1zM192.3 224H160.3V192H192.3V224z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/file-archive.js
// module id = hg1Q
// module chunks = 0